import styled from 'styled-components'

export const StyledPopOverTagContent = styled.div`
  .ant-typography {
    display: block;
    white-space: initial;
  }

  .details {
    display: block;
    max-width: 200px;
    white-space: initial;
    margin-bottom: 5px;
  }

  .statusTag {
    cursor: pointer;
    opacity: 0.5;
    &:hover,
    &.active {
      opacity: 1;
    }
  }

  .eventSpinner {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 10;
  }

  .ant-descriptions-view {
    border-radius: 10px;
  }

  .ant-btn-link {
    padding: 0;

    span {
      font-weight: 700;
    }
  }

  .tooltipTag {
    padding: 0 !important;
    margin: 0 !important;
    display: block;
    .ant-descriptions,
    .ant-descriptions-view,
    table,
    tr,
    th,
    .ant-descriptions-item-label,
    .ant-descriptions-item-content {
      border-color: inherit !important;
    }

    .ant-descriptions-item-content {
      background-color: #ffffff !important;
    }

    .ant-descriptions-item-label {
      background-color: inherit !important;
    }

    .tagsContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      flex-flow: row wrap;

      & > span {
        margin: 4px;
      }
    }

    .ant-descriptions-bordered .ant-descriptions-item-label:last-child,
    .ant-descriptions-bordered .ant-descriptions-item-content:last-child {
      border-right-width: ${props => (props.rtl ? '1px' : 'none')};
      border-right-style: ${props => (props.rtl ? 'solid' : 'none')};
    }
  }
`
